<template>
  <item-list :categories="categories" :items="items" filter-mode="or-or">
    <template #default="{ item }">
      <print-item :item="item"></print-item>
    </template>
  </item-list>
</template>

<script setup lang="ts">
import ItemList from '../../components/ItemList.vue';
import PrintItem from '../../components/PrintItem.vue';
import type Category from '../../common/Category';
import { type CatalogItem } from '../../common/CatalogItem';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
  categories: Category[];
  items: CatalogItem[];
}>();
</script>
